'use client'
import { ChevronRightIcon } from '@repo/ui/ChevronRightIcon'
import { MicrosoftLogo } from '@repo/ui/MicrosoftLogo'
import { useAuthenticationStore } from '@repo/store/useAuthenticationStore'
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useState } from 'react'
import { useUrlStore } from '@repo/store/useUrlStore'
import Cookie from 'js-cookie'
import MUIButton from '@mui/material/Button'
import MUIStack from '@mui/material/Stack'
import MUITypography from '@mui/material/Typography'

const Outlook = () => {
  const { userId } = useAuthenticationStore()
  const { queryParams } = useUrlStore()
  const [success, setSuccess] = useState(false)
  const [message, setMessage] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    const handleEmailSetup = async () => {
      const { success, accessToken, refreshToken, expires } = queryParams || {}

      if (success === true || success === 'true') {
        const cookieExpiryDate = new Date()
        cookieExpiryDate.setDate(cookieExpiryDate.getDate() + 90)

        if (accessToken) {
          Cookie.set(`${userId}MsToken`, accessToken, { expires: cookieExpiryDate })
        }

        if (refreshToken) {
          Cookie.set(`${userId}MsRefreshToken`, refreshToken, { expires: cookieExpiryDate })
        }

        if (expires) {
          // setting this cookie the old fashioned way because js-cookie url-encodes the value and it causes Osprey 1 to throw an error
          document.cookie = `${userId}MsTokenExpire=${expires.replace('+', ' ')}; expires=${cookieExpiryDate.toUTCString()}; path=/;`
        }

        setSuccess(true)

        setMessage(
          'Your Outlook integration has been set up successfully! You will now be able to sync Key Dates to your Outlook calendar.'
        )
      } else {
        setMessage('There was an error setting up your Outlook integration. Please try again.')
      }
    }

    handleEmailSetup()
  }, [queryParams, userId])

  const handleClickToTrayAgain = () => {
    navigate('/configuration/microsoft/outlook-setup')
  }

  return (
    <MUIStack
      data-testid="Outlook"
      gap={6}
      sx={{ maxWidth: 680, margin: 'auto', backgroundColor: 'white', borderRadius: '6px', padding: '60px 40px' }}
    >
      <MicrosoftLogo sx={{ width: '220px', height: 'auto', marginBottom: 3 }} />
      <MUITypography variant="body1">{message}</MUITypography>

      {!success ? (
        <MUIButton
          variant="contained"
          color="primary"
          size="large"
          onClick={handleClickToTrayAgain}
          sx={{ maxWidth: 160, width: '100%', margin: '20px 0 0 auto' }}
        >
          <ChevronRightIcon sx={{ color: 'white', transform: 'rotate(180deg)' }} />
          Back
        </MUIButton>
      ) : null}
    </MUIStack>
  )
}

export default Outlook
